import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
export class MsGraphApiHelper {
    constructor() { }
    // Right now in ms-graph-api.service.ts, we are mapping values from the old Azure AD Graph API to the format from
    // the Microsoft Graph API so that code that relies on the old data structure doesn't break.
    mapUserProfileToOldGraphApi(newUserProfile) {
        const oldUserProfile = {
            city: newUserProfile.city,
            companyName: newUserProfile.companyName,
            country: newUserProfile.country,
            displayName: newUserProfile.displayName,
            givenName: newUserProfile.givenName,
            lastDirSyncTime: newUserProfile.lastDirSyncTime,
            mail: newUserProfile.mail,
            mailNickname: newUserProfile.mailNickname,
            objectId: newUserProfile.id,
            manager: newUserProfile.manager
                ? this.mapUserProfileToOldGraphApi(newUserProfile.manager)
                : null,
            surname: newUserProfile.surname,
            thumbnailPhotoUrl: newUserProfile.thumbnailPhotoUrl,
            usageLocation: newUserProfile.usageLocation,
            userPrincipalName: newUserProfile.userPrincipalName,
            userType: newUserProfile.userType
        };
        return oldUserProfile;
    }
    static { this.ɵfac = function MsGraphApiHelper_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MsGraphApiHelper)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MsGraphApiHelper, factory: MsGraphApiHelper.ɵfac, providedIn: 'root' }); }
}
//# sourceMappingURL=ms-graph-api.helper.js.map